export function HiddenField({name, value}: {name: string; value?: string}) {
  return <input name={name} type="hidden" value={value} />
}
